import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { IAction } from '~/src/store';

export type TSetSpeedRestrictionsProps = {
    min?: number,
    max?: number,
}

const setSpeedRestrictions = (restrictions: TSetSpeedRestrictionsProps): IAction<
    EAction.SetSpeedRestrictions,
    { restrictions: TSetSpeedRestrictionsProps }
> => ({
    type: EAction.SetSpeedRestrictions,
    payload: {
        restrictions,
    },
});

export default setSpeedRestrictions;
